import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CheckoutPaymentCustomPaymentServicePage } from 'src/app/modals/checkout-payment-custom-payment-service/checkout-payment-custom-payment-service.page';

const routes: Routes = [
  {
    path: '',
    component: CheckoutPaymentCustomPaymentServicePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CheckoutPaymentCustomPaymentServicePage]
})
export class CheckoutPaymentCustomPaymentServicePageModule {}
